/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 * See the LICENSE file for the full text.
 */

import React from 'react';
import OrgField from './OrgField';

/**
 * A multi-line input with a live character count.
 *
 * The count is shown rather than silently enforced. `maxLength` stops typing at
 * the cap, but a value loaded from an event created before the cap existed can
 * already be over it — and an organizer who cannot see why saving is refused
 * has no way to fix it. Over the cap the counter turns to the error colour and
 * `validateEventForm` produces the blocking message.
 */
export default function OrgTextArea({
  label, value, onChange, required, error, help, placeholder, maxLength, rows,
}) {
  const length = (value || '').length;
  const over = maxLength != null && length > maxLength;

  return (
    <OrgField label={label} required={required} error={error} help={help}>
      {({ id, invalid, describedBy }) => (
        <>
          {maxLength != null && (
            <span className={`orgf-count${over ? ' over' : ''}`}>{length}/{maxLength}</span>
          )}
          <textarea
            id={id}
            className="orgf-area"
            value={value ?? ''}
            rows={rows}
            placeholder={placeholder}
            maxLength={maxLength}
            aria-invalid={invalid}
            aria-describedby={describedBy}
            onChange={(event) => onChange(event.target.value)}
          />
        </>
      )}
    </OrgField>
  );
}
